import { render, staticRenderFns } from "./state-config.vue?vue&type=template&id=808b9dda"
import script from "./state-config.ts?vue&type=script&lang=js&external"
export * from "./state-config.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports